export function addZeros(number) {
  if (String(number).length < 5 ) {
    number = "0" + number
    number = addZeros(number)
  }
  return number
}

export function createArrOfObj(value, price) {
  const result = []
  for (let i = 0; i < value.length; i++) {
    result.push({
      value: value[i],
      price: price[i],
      id: i
    })
  }

  return result
}

export class User {
  constructor(data) {
    this.name = data.name
    this.clicks = data.clicks
    this.difficult = data.difficult
  }

}